import { TOKEN_KEY } from '@/constant/common'

interface DecodedToken {
  exp?: number
  iat?: number
  [key: string]: any
}

export const decodeJWT = (token: string): DecodedToken | null => {
  try {
    const parts = token.split('.')
    if (parts.length !== 3) {
      return null
    }

    const payload = parts[1]
    const decoded = atob(payload.replace(/-/g, '+').replace(/_/g, '/'))
    return JSON.parse(decoded)
  } catch (error) {
    return null
  }
}

export const isTokenExpired = (token: string): boolean => {
  const decoded = decodeJWT(token)
  if (!decoded || !decoded.exp) {
    return true
  }

  const currentTime = Math.floor(Date.now() / 1000)
  return decoded.exp < currentTime
}

export const getStoredToken = (): string | null => {
  try {
    return localStorage.getItem(TOKEN_KEY)
  } catch (error) {
    return null
  }
}

export const clearAllStorage = (): void => {
  try {
    localStorage.clear()
    sessionStorage.clear()
  } catch (error) {
    console.error('Failed to clear storage:', error)
  }
}
